/* Galerie & Kunsthaus Nottbohm — Kontaktformular
   1. Ankreuzfelder für Einrahmung und Lieferung, nur bei Werkanfragen
   2. Datenschutzzeile: Textstücke zu einem Element zusammenfassen, damit
      die Zeile denselben Aufbau hat wie die Ankreuzfelder darüber
   3. Nachrichtenfeld wächst mit dem Inhalt mit
   4. Nach dem Absenden auf die Bestätigungsseite /pages/danke weiterleiten.
      Kam die Anfrage von einer Werkseite, merkt sich die Seite die Kollektion
      des Künstlers (gesetzt in snippets/nottbohm-anfrage.liquid), damit die
      Bestätigungsseite einen Button zurück zur Kollektion zeigen kann.
   Nicht Teil des Impression-Themes.
*/
(function () {
	"use strict";

	var DANKE = "/pages/danke";

	function saeubern(t) {
		return (t || "").replace(/\s+/g, " ").trim().toLowerCase();
	}

	function kontaktformular() {
		var f = document.querySelectorAll('form[action*="/contact"]');
		for (var i = 0; i < f.length; i++) {
			if (f[i].querySelector("textarea")) return f[i];
		}
		return null;
	}

	/* ---- 1. Ankreuzfelder ---- */

	function anfrageoptionen() {
		var p = new URLSearchParams(window.location.search);
		var werk = p.get("werk");
		if (!werk) return;
		if (document.querySelector(".nb-optionen")) return;

		var formular = kontaktformular();
		if (!formular) return;
		var textfeld = formular.querySelector("textarea");
		if (!textfeld) return;

		var anliegen = p.get("anliegen") || "";

		var box = document.createElement("div");
		box.className = "nb-optionen";

		var frage = document.createElement("p");
		frage.className = "nb-optionen-frage";
		frage.textContent = "Wobei dürfen wir dich unterstützen?";
		box.appendChild(frage);

		[
			{ schluessel: "Einrahmung", text: "Einrahmung in eurer Werkstatt" },
			{ schluessel: "Lieferung", text: "Lieferung – bitte um ein Angebot" }
		].forEach(function (option) {
			var zeile = document.createElement("label");
			zeile.className = "nb-option";

			var haken = document.createElement("input");
			haken.type = "checkbox";
			haken.name = "contact[" + option.schluessel + "]";
			haken.value = "Ja";
			if (anliegen === option.schluessel) haken.checked = true;

			var beschriftung = document.createElement("span");
			beschriftung.className = "nb-option-text";
			beschriftung.textContent = option.text;

			zeile.appendChild(haken);
			zeile.appendChild(beschriftung);
			box.appendChild(zeile);
		});

		var anker = textfeld.closest("div") || textfeld;
		anker.parentNode.insertBefore(box, anker);
	}

	/* ---- 2. Datenschutzzeile ---- */

	function datenschutzzeile() {
		var formular = kontaktformular();
		if (!formular) return;
		if (formular.querySelector(".nb-datenschutz")) return;

		var haken = formular.querySelectorAll('input[type="checkbox"]');
		Array.prototype.forEach.call(haken, function (h) {
			if (h.closest(".nb-optionen")) return;

			var zeile = h.closest("label") || h.parentElement;
			while (zeile && zeile !== formular) {
				if (saeubern(zeile.textContent).indexOf("datenschutz") > -1) break;
				zeile = zeile.parentElement;
			}
			if (!zeile || zeile === formular) return;

			// Alles außer dem Kästchen in ein einziges Element fassen.
			// Danach besteht die Zeile aus zwei Teilen — wie die Ankreuzfelder.
			var text = document.createElement("span");
			text.className = "nb-datenschutz-text";
			var knoten = Array.prototype.slice.call(zeile.childNodes);
			knoten.forEach(function (n) {
				if (n === h) return;
				if (n.contains && n.contains(h)) return;
				text.appendChild(n);
			});

			zeile.appendChild(text);
			zeile.insertBefore(h, text);
			zeile.classList.add("nb-datenschutz");
		});
	}

	/* ---- 3. Nachrichtenfeld mitwachsen lassen ---- */

	function feldWachsen() {
		var formular = kontaktformular();
		if (!formular) return;
		var feld = formular.querySelector("textarea");
		if (!feld) return;
		feld.classList.add("nb-nachricht");

		function anpassen() {
			feld.style.height = "auto";
			var noetig = feld.scrollHeight;
			var mindest = parseFloat(window.getComputedStyle(feld).minHeight) || 0;
			feld.style.height = Math.max(noetig, mindest) + "px";
		}

		if (!feld.getAttribute("data-nb-wachsen")) {
			feld.setAttribute("data-nb-wachsen", "1");
			feld.addEventListener("input", anpassen);
		}
		anpassen();
	}

	/* ---- 4. Bestätigungsseite ---- */

	// Rückfall: Landet das Formular doch wieder auf der Kontaktseite
	// (Shopify hängt dann ?contact_posted=true an), sofort weiterleiten.
	function schonAbgeschickt() {
		var p = new URLSearchParams(window.location.search);
		if (p.get("contact_posted") !== "true") return false;
		if (window.location.pathname === DANKE) return false;
		window.location.replace(DANKE);
		return true;
	}

	function zurBestaetigung() {
		var formular = kontaktformular();
		if (!formular || formular.getAttribute("data-nb-danke")) return;
		formular.setAttribute("data-nb-danke", "1");

		// return_to sagt Shopify, wohin nach erfolgreichem Absenden weitergeleitet wird.
		var ziel = formular.querySelector('input[name="return_to"]');
		if (!ziel) {
			ziel = document.createElement("input");
			ziel.type = "hidden";
			ziel.name = "return_to";
			formular.appendChild(ziel);
		}
		ziel.value = DANKE;

		formular.addEventListener("submit", function () {
			try {
				var p = new URLSearchParams(window.location.search);
				var kollektion = null;
				if (p.get("werk")) {
					kollektion = JSON.parse(window.sessionStorage.getItem("nb_letzte_kollektion") || "null");
					var kuenstler = p.get("kuenstler");
					if (kollektion && kuenstler && kollektion.titel !== kuenstler) kollektion = null;
				}
				if (kollektion && kollektion.url) {
					window.sessionStorage.setItem("nb_danke", JSON.stringify(kollektion));
				} else {
					window.sessionStorage.removeItem("nb_danke");
				}
			} catch (e) {}
		});
	}

	function start() {
		anfrageoptionen();
		datenschutzzeile();
		feldWachsen();
		zurBestaetigung();
	}

	if (schonAbgeschickt()) return;

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}

	window.addEventListener("load", start);

	if (window.MutationObserver) {
		var wartet = false;
		new MutationObserver(function () {
			if (wartet) return;
			wartet = true;
			window.setTimeout(function () { wartet = false; start(); }, 300);
		}).observe(document.body, { childList: true, subtree: true });
	}
})();
